import type { TTagOptionValue } from '@cian/ui-kit';
import { TJsonQuery } from '../../../../packages/JsonQuery';
import { tagsManagers } from '../managers';
import { parseTagValue } from './parseTagValue';

interface IParams {
  jsonQuery: TJsonQuery;
  removingTagValue: TTagOptionValue;
}

export const modifyJsonQueryByRemovingTag = ({ jsonQuery, removingTagValue }: IParams): TJsonQuery => {
  const [tagId, tagValue = ''] = parseTagValue(removingTagValue);

  const removingTagManager = tagsManagers.find(({ id }) => tagId === id);

  if (!removingTagManager) {
    return jsonQuery;
  }

  return removingTagManager.modifyJsonQueryByRemovingTag({ jsonQuery, removingTagValue: tagValue });
};
